export enum UserRole {
  Owner = 'owner',
  Admin = 'admin',
  User = 'normal'
}

export type UserRoleString = `${UserRole}`
